//#region Imports
import moment from 'moment';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Skeleton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import '../../../scss/Components/_modal.scss';
import 'react-toastify/dist/ReactToastify.css';
import ModalRecurrVisit from '../ModalRecurrVisit';
import customAxios from '../../../utils/customAxios';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';

// const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
// const checkedIcon = <CheckBoxIcon fontSize='small' />;
//#endregion

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

function ModalV(props) {
  const { visitVisitDateString } = useTranslationHook();

  const [techs, setTechs] = useState([]);
  const [visitTypes, setVisitTypes] = useState([]);
  const [visitClients, setVisitClients] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [visitTypeId, setVisitTypeId] = useState('');
  const [visitClientId, setVisitCliendId] = useState(null);
  const [visitSiteId, setVisitSiteId] = useState('');
  const [visitTechId, setVisitTechId] = useState('');
  const [description, setDescription] = useState('');
  const [assetIds, setAssetIds] = useState([]);
  const [futureVisit, setFutureVisit] = useState(0);
  const [date, setDate] = useState(moment());
  const [notes, setNotes] = useState('');
  const [concurrenceId, setConcurrenceId] = useState('');
  const [visitClientSites, setVisitClientSites] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [modalRVisitShow, setModalRVisitShow] = useState(false);
  const [recurrentDates, setRecurrentDates] = useState([]);
  const [clientsTi, setClientsTi] = useState([]);
  const [visitClientTi, setVisitClientTi] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [failureTypes, setFailureTypes] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(15); // GENERAL CF, única opción del server
  const [oxxoTicket, setOxxoTicket] = useState('');
  const [ticket_date, setTicketDate] = useState(moment());
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.show) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    if (visitClientId) {
      fetchClientSites(visitClientId);
      fetchClientTechs(visitClientId);
    } else {
      setVisitClientSites([]);
      setVisitSiteId(null);
      setTechs([]);
      setVisitTechId(null);
    }
  }, [visitClientId]);

  const fetchAutofillVists = async () => {
    const endpoint = `${GlobalVariables.getURL()}autofillVisits`;
    const response = await customAxios.get(endpoint, HEADERS);

    return response.data;
  };

  const fetchFailureTypes = async () => {
    const endpoint = `${GlobalVariables.getURL()}failure-types/`;
    const response = await customAxios.get(endpoint, HEADERS);

    return response.data.data;
  };

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const [autofillVisitsData, failureTypesData] = await Promise.all([
        fetchAutofillVists(),
        fetchFailureTypes(),
      ]);

      setVisitTypes(
        autofillVisitsData.visitTypes ? autofillVisitsData.visitTypes : [],
      );
      setVisitClients(
        autofillVisitsData.clients ? autofillVisitsData.clients : [],
      );
      setFailureTypes(failureTypesData ? failureTypesData : []);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchClientSites = async (id) => {
    try {
      const endpoint = `${GlobalVariables.getURL()}listClientSites/${id}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setVisitClientSites([]);
        return;
      }

      setVisitClientSites(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  const fetchClientTechs = async (id) => {
    try {
      const endpoint = `${GlobalVariables.getURL()}technicals/clients/${id}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setTechs([]);
        return;
      }

      setTechs(response.data.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  const fetchClientsTi = async (id) => {
    try {
      const endpoint = `${GlobalVariables.getURL()}client-ti/listClientTiBySiteID/${id}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204 || response.data.data.length === 0) {
        setClientsTi([]);
        setVisitClientTi(null);
        return;
      }

      const tiList = response.data.data;

      setClientsTi(tiList);
      setVisitClientTi(tiList[0].id); // 👈 autoselección
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  useEffect(() => {
    if (visitSiteId) {
      fetchClientsTi(visitSiteId);
    } else {
      setClientsTi([]);
      setVisitClientTi(null);
    }
  }, [visitSiteId]);

  /*  const getAssetsOfSite = async (value) => {
    const response = await customAxios.get(
      `${GlobalVariables.getURL()}autofillAssets/${value}`,
      {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return response.data;
  }; */

  const isToday = () => {
    const today = moment();
    const selectedDate = moment(date);
    return today.isSame(selectedDate, 'day');
  };

  const hide = () => {
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Servicio creado exitosamente en la base de datos.',
    });
  };

  const createVisit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    let dates;
    let recurrenceId = isChecked ? concurrenceId : 0; // Agrega esta línea

    if (isChecked) {
      dates = recurrentDates.map((date) => date.toISOString());
      dates.unshift(date.toISOString());
    } else {
      dates = date.toISOString();
    }

    const selectedClientTiName =
      clientsTi.find((ct) => ct.id === visitClientTi)?.full_name || null;

    try {
      const endpoint = `${GlobalVariables.getURL()}createVisit`;
      const response = await customAxios.post(
        endpoint,
        {
          business_name: visitClientId,
          site_id: visitSiteId,
          asset_ids: assetIds,
          technical_id: visitTechId,
          visit_type_id: visitTypeId,
          description: description,
          visit_date: dates,
          future_visit: futureVisit,
          concurrence_id: recurrenceId,
          oxxo_ticket: oxxoTicket,
          client_ti: selectedClientTiName, // 👈 AQUÍ va el name
          failure_type_id: failureTypeId,
          failure_note: notes,
          ticket_date: ticket_date.toISOString(),
          final_status_id: 1,
        },
        HEADERS,
      );

      if (response.status === 200) {
        hide();
        props.getVisits();
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const calculateNextVisits = (startDate, frequency) => {
    const start = moment(startDate);
    const dates = [];
    let interval;

    switch (frequency) {
      case 'monthly':
        interval = 1;
        break;
      case 'bimonthly':
        interval = 2;
        break;
      case 'quarterly':
        interval = 3;
        break;
      case 'tetra':
        interval = 4;
        break;
      case 'semiannual':
        interval = 6;
        break;
      default:
        throw new Error('Frecuencia no soportada.');
    }

    // Generar las siguientes fechas en base a la frecuencia
    for (let i = 1; i <= 12; i++) {
      let nextVisitDate = start.clone().add(i * interval, 'months');
      // Detener el cálculo si la siguiente fecha está más allá de 11 meses desde la fecha inicial
      if (nextVisitDate.diff(start, 'months') > 11) {
        break;
      }
      dates.push(nextVisitDate);
    }

    return dates;
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handlePersRecurr = (event) => {
    setShowButton(true);
    let dates;

    switch (event.target.value) {
      case 1:
        dates = calculateNextVisits(date, 'monthly');
        setConcurrenceId(1); // Agrega esta línea
        break;
      case 2:
        dates = calculateNextVisits(date, 'bimonthly');
        setConcurrenceId(2); // Agrega esta línea
        break;
      case 3:
        dates = calculateNextVisits(date, 'quarterly');
        setConcurrenceId(3); // Agrega esta línea
        break;
      case 4:
        dates = calculateNextVisits(date, 'tetra');
        setConcurrenceId(4); // Agrega esta línea
        break;
      default:
        dates = calculateNextVisits(date, 'semiannual');
        setConcurrenceId(5); // Agrega esta línea
    }

    setRecurrentDates(dates);
    setModalRVisitShow(true);
  };

  const resetFormFields = () => {
    setVisitCliendId('');
    setVisitSiteId('');
    setVisitTypeId('');
    setVisitTechId('');
    setAssetIds([]);
    setDescription('');
    setFutureVisit(0);
    setDate(moment());
    setTicketDate(moment());
    setNotes('');
    setIsChecked(false);
    setRecurrentDates([]);
    setModalRVisitShow(false);
    setShowButton(false);
    setOxxoTicket('');
    setFailureTypeId(15);
    setFailureTypes([]);
    setClientsTi([]);
    setVisitClientTi(null);
  };

  const handleChangeDate = (index, newDate) => {
    const updatedDates = [...recurrentDates];
    updatedDates[index] = moment(newDate);
    setRecurrentDates(updatedDates);
  };

  useEffect(() => {
    // Al cambiar cliente, limpiar TI y lista
    setVisitClientTi(null);
    setClientsTi([]);
  }, [visitClientId]);

  return (
    <>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="modal-backdrop"
        onExiting={resetFormFields}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <Typography className="inventory-movmodal-title">
              Nuevo Servicio
            </Typography>
          </Modal.Title>
        </Modal.Header>
        <LocalizationProvider
          dateAdapter={AdapterMoment}
          adapterLocale={moment.locale()}
        >
          <Modal.Body>
            <form id="visits-form" onSubmit={createVisit}>
              <div className="row">
                <div className="col-md-12">
                  {isFetching ? (
                    <Skeleton variant="rounded" height={56} />
                  ) : (
                    <Autocomplete
                      disabled={isLoading}
                      value={
                        visitClients.find((c) => c.id === visitClientId) || null
                      }
                      options={visitClients}
                      getOptionLabel={(vc) => vc.business_name}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          disabled={isLoading}
                          label="Plaza"
                          placeholder="Plaza..."
                          {...params}
                          required
                        />
                      )}
                      onChange={(_, newValue) =>
                        setVisitCliendId(newValue ? newValue.id : null)
                      }
                    />
                  )}
                </div>
              </div>

              <br />

              <div className="row">
                <div className="col-md-6">
                  <Autocomplete
                    disabled={!visitClientId || isLoading}
                    value={
                      visitClientSites.find((vs) => vs.id === visitSiteId) ||
                      null
                    }
                    options={visitClientSites}
                    getOptionLabel={(visitClientSites) =>
                      visitClientSites?.cr
                        ? '[' +
                          visitClientSites.cr +
                          ']' +
                          ' - ' +
                          visitClientSites.site_name
                        : visitClientSites.site_name
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={!visitClientId || isLoading}
                        {...params}
                        label="Sucursal"
                        placeholder="Sucursal..."
                        required
                      />
                    )}
                    onChange={(_, newValue) =>
                      setVisitSiteId(newValue ? newValue.id : null)
                    }
                  />
                  {/* <Typography variant='caption'>
                    Debes seleccionar un cliente antes de seleccionar un sitio.
                  </Typography> */}
                </div>
                <div className="col-md-6">
                  <TextField
                    disabled
                    fullWidth
                    label="Tipo de servicio"
                    value="GENERAL CF"
                  />
                </div>
              </div>

              <br />

              <div className="row">
                <div className="col-md-6">
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    required
                    label="Ticket"
                    placeholder="Ticket..."
                    value={oxxoTicket}
                    onChange={(e) => setOxxoTicket(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <div />
                </div>
              </div>

              {/* Commenting since sigma doesnt use assets */}
              {/* <div className='row'>
                <div className='col-md-12'>
                  <Autocomplete
                    multiple
                    limitTags={3}
                    disablePortal
                    disableCloseOnSelect
                    includeInputInList={false}
                    options={siteAssets}
                    sx={{ width: '100%' }}
                    getOptionLabel={(siteAssets) => siteAssets.asset_name}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.asset_name}
                      </li>
                    )}
                    getOptionSelected={(siteAssets, value) =>
                      siteAssets.id === value.id
                    }
                    disabled={siteSelection === ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Seleccionar equipo...'
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setAssetIds(newValue.map((asset) => asset.id));
                    }}
                  />
                  <Typography variant="caption">
                    Debes seleccionar una sucursal antes de seleccionar equipo(s).
                  </Typography>
                </div>
              </div> */}

              <br />

              <div className="row">
                <div className="col-md-6">
                  <DateTimePicker
                    disabled={isLoading}
                    label="Fecha y hora del ticket"
                    value={ticket_date}
                    onChange={(newDate) => {
                      setTicketDate(newDate);
                    }}
                    slotProps={{
                      textField: {
                        disabled: isLoading,
                        required: true,
                        fullWidth: true,
                      },
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <DateTimePicker
                    disabled={isLoading}
                    label={'Fecha y hora de asignación del técnico'}
                    value={date}
                    onChange={(newDate) => {
                      setDate(newDate);
                    }}
                    slotProps={{
                      textField: {
                        disabled: isLoading,
                        fullWidth: true,
                      },
                    }}
                  />
                </div>
                <div className="col-md-6"></div>
              </div>

              <br />

              <div className="row">
                <div className="col-md-4">
                  <Autocomplete
                    disabled={isLoading}
                    value={
                      visitTypes.find((vt) => vt.id === visitTypeId) || null
                    }
                    options={visitTypes}
                    getOptionLabel={(visitTypes) => visitTypes.vt_name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="Actividad"
                        placeholder="Actividad..."
                        required
                      />
                    )}
                    onChange={(_, newValue) => {
                      setVisitTypeId(newValue ? newValue.id : null);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Autocomplete
                    disabled={!visitClientId || isLoading}
                    value={techs.find((t) => t.id === visitTechId) || null}
                    options={techs}
                    getOptionLabel={(techs) => techs.full_name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        disabled={!visitClientId || isLoading}
                        label="Técnico asignado"
                        placeholder="Técnico asignado..."
                      />
                    )}
                    onChange={(_, newValue) => {
                      setVisitTechId(newValue ? newValue.id : null);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Autocomplete
                    disabled={!visitSiteId || isLoading}
                    value={
                      clientsTi.find((ct) => ct.id === visitClientTi) || null
                    }
                    options={clientsTi}
                    getOptionLabel={(item) => item.full_name || item.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        disabled={!visitSiteId || isLoading}
                        label="Contacto sucursal"
                        placeholder="Contacto sucursal"
                      />
                    )}
                    onChange={(_, newValue) => {
                      setVisitClientTi(newValue ? newValue.id : null);
                    }}
                  />
                </div>
              </div>

              {/* <br />

              <div className='row align-items-center'>
                <div className='col-md-6'>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby='demo-radio-buttons-group-label'
                      name='radio-buttons-group'
                      value={futureVisit}
                      onChange={(e) => setFutureVisit(e.target.value)}
                    >
                      <FormControlLabel
                        disabled={isLoading}
                        value='0'
                        control={<Radio />}
                        label="Generar servicio inmediatamente."
                      />
                      <FormControlLabel
                        disabled={isLoading}
                        value='1'
                        control={<Radio disabled={isToday()} />}
                        label="Generar servicio hasta el día establecido."
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className='col-md-6'>
                  <Tooltip
                    title='Nota: El cálculo se hace con base a la fecha inicial seleccionada.'
                    arrow
                  >
                    <FormControlLabel
                      disabled={isLoading}
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label='¿Es recurrente?'
                    />
                  </Tooltip>
                  {isChecked && (
                    <Select
                      required
                      sx={{ width: '100%' }}
                      onChange={handlePersRecurr}
                      placeholder='Ayuda'
                    >
                      <MenuItem value={1}>Mensual</MenuItem>
                      <MenuItem value={2}>Bimestral</MenuItem>
                      <MenuItem value={3}>Trimestral</MenuItem>
                      <MenuItem value={4}>Tetramestral</MenuItem>
                      <MenuItem value={5}>Semestral</MenuItem>
                    </Select>
                  )}
                  {isChecked && showButton && (
                    <Button
                      onClick={() => setModalRVisitShow(true)}
                      size='small'
                    >
                      Ver fechas
                    </Button>
                  )}
                </div>
              </div> */}

              <br />

              <div className="row">
                <div className="col-md-12">
                  <TextField
                    disabled={isLoading}
                    multiline
                    fullWidth
                    required
                    label="Comentarios del servicio"
                    placeholder="Comentarios del servicio..."
                    rows={4}
                    type="text"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
        </LocalizationProvider>
        <Modal.Footer>
          <Button
            type="submit"
            variant="contained"
            form="visits-form"
            className="save-modal-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size="2rem" />
            ) : (
              <Typography>Guardar</Typography>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <ModalRecurrVisit
        show={modalRVisitShow}
        dates={recurrentDates}
        onHide={() => setModalRVisitShow(false)}
        onChange={handleChangeDate}
      />
    </>
  );
}

export default ModalV;
